<template>
    <form-common-config
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template #fieldSpecific="{rec}">
            <div class="d-flex">
                <fe-label :style="labelStyle">Trailing Label</fe-label>
                <v-text-field flat solo dense
                    :value="rec.box_label"
                    @change="rec.box_label = $event"
                    :rules="$fieldValidators('text', null, {limit:500})"
                />
            </div>
        </template>
    </form-common-config>
</template>

<script>
import FormCommonConfig from '../FormCommonConfig'

export default {
    components: {
        FormCommonConfig,
    },
    computed: {
        labelStyle: me => ({ minWidth:'120px' }),
    },
}
</script>

<style lang="scss" scoped>
</style>
